import "./Home.css";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Carousel from "react-bootstrap/Carousel";


function Kontakt() {
  return (
    <div className="hero-container">
      <Container className="py-3">
      <Row className="justify-content-center">
  <Col xs={12} md={8} lg={6}>
    <Card className="shadow-lg bg-transparent border-0">
      <Card.Body className="text-white">
        <h3 className="text-center mb-4">Kontaktieren Sie uns</h3>
        <form>
          <div className="mb-3">
            <label htmlFor="name" className="form-label text-white">
              Name
            </label>
            <input
              type="text"
              className="form-control bg-dark text-white border-0"
              id="name"
              placeholder="Ihr Name"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label text-white">
              E-Mail
            </label>
            <input
              type="email"
              className="form-control bg-dark text-white border-0"
              id="email"
              placeholder="Ihre E-Mail-Adresse"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="message" className="form-label text-white">
              Nachricht
            </label>
            <textarea
              className="form-control bg-dark text-white border-0"
              id="message"
              rows="4"
              placeholder="Ihre Nachricht"
            ></textarea>
          </div>
          <div className="d-grid">
            <Button variant="outline-light" type="submit">
              Senden
            </Button>
          </div>
        </form>
      </Card.Body>
    </Card>
  </Col>
</Row>
    </Container>
    </div>
  );
}

export default Kontakt;